import { Form, PaymentMethod, InvoiceAddressChoice } from './PaymentForm.types'

export const INITIAL_FORM_VALUES: Form = {
  referenceNumber: '',
  paymentParams: '',
  paymentMethod: PaymentMethod.iDeal,
  invoiceAddressChoice: InvoiceAddressChoice.UseExistingAddress,
  address: '',
  city: '',
  postalCode: '',
  companyName: '',
  country: 'Netherlands',
}
